import { dataSortAsc } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSortAsc = /*#__PURE__*/createIcon(dataSortAsc)
export default IconSortAsc
